export default __webpack_public_path__ + "static/media/Banswara Syntex Limited.b81051d6.jpg";